import routerOptions0 from "/usr/src/app/content/n3-redirections-service-974853cc-ff48-402e-8485-282b90218cea/b2c-build/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}